import {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

function Row(props) {
    var item = props.item
    var eventSelect = props.eventSelect
    var eventDelete = props.eventDelete

    return(
        <TableRow>
            <TableCell>{item.tipo}</TableCell>
            <TableCell>{item.protocolo}</TableCell>
            <TableCell>{item.puerto}</TableCell>
            <TableCell>{item.velocidad}</TableCell>
            <TableCell>{item.archivo}</TableCell>
            <TableCell>{item.debug}</TableCell>
            <TableCell>{item.estado}</TableCell>
            <TableCell>
                <Button variant="contained" size='small' fullWidth onClick={() => {eventSelect(item)}}>Seleccionar</Button>
                <Button variant="contained" size='small' color="error" fullWidth onClick={() => {eventDelete(item)}}>Borrar</Button>
            </TableCell>
        </TableRow>
    )
}


class TabImpresoras extends Component {
    constructor(props) {
        super(props)

        var tipoDispositivo = props.tipoDispositivo
        var dispositivos = props.dispositivos
        this.guardarEvent = props.event

        this.state = {
            tipoDispositivo: tipoDispositivo,
            dispositivos: dispositivos,
            itemEdicion: null,
            cmbTiposImpresora: 0,
            cmbProtocolos: 0,
            cmbVelocidades: 0,
            cmbDebugs: 0,
            txtPuerto: "",
            txtArchivo: "",
            cmbEstados: 0,
            tiposImpresora: [
                "Q10",
                "TECMAX",
                "TITO-EDGE",
                "Otro"
            ],
            protocolos: [
                "ESC/POS",
                "ESC/POS-USB",
                "USB"
            ],
            velocidades: [
                "9600",
                "19200",
                "115200"
            ],
            debugs: [
                "1",
                "2",
                "3",
                "4"
            ],
            estados: [
				{nombre: "Activo", valor: "A"},
				{nombre: "Inactivo", valor: "I"}
			],
            modoEdicion: false
        }
    }

    componentWillUnmount() {

    }

    onChangecmbTiposImpresora = (event) => {
        const tipo = event.target.value
        this.setState({cmbTiposImpresora: tipo})
    }

    onChangecmbProtocolos = (event) => {
        const protocolo = event.target.value
        this.setState({cmbProtocolos: protocolo})
    }

    onChangecmbDebugs = (event) => {
        const debug = event.target.value
        this.setState({cmbDebugs: debug})
    }

    onChangetxtPuerto = (event) => {
        const puerto = event.target.value.toString()
        this.setState({txtPuerto: puerto})
    }

    onChangecmbVelocidades = (event) => {
        const velocidad = event.target.value
        this.setState({cmbVelocidades: velocidad})
    }

    onChangetxtArchivo = (event) => {
        const archivo = event.target.value.toString()
        this.setState({txtArchivo: archivo})
    }
    
    onChangecmbEstados = (event) => {
        const estado = event.target.value
        this.setState({cmbEstados: estado})
    }

    btnSeleccionarClick = (item) => {
        this.setState({
            itemEdicion: item,
            cmbTiposImpresora: item.tipo,
            cmbProtocolos: item.protocolo,
            txtPuerto: item.puerto,
            cmbVelocidades: item.velocidad,
            txtArchivo: item.archivo,
            cmbDebugs: item.debug,
            cmbEstados: item.estado,
            modoEdicion: true
        })
    }

    btnBorrarClick = (item) => {
        
        if(window.confirm("¿Borrar dispositivo?")) {
            this.pepararNuevo()
            var dispositivos = this.state.dispositivos

            var x = dispositivos.indexOf(item)
            if(x >= 0) dispositivos.splice(x, 1)


            this.setState({
                dispositivos: dispositivos
            })

            this.guardarEvent(this.state.tipoDispositivo, this.state.dispositivos, this.confirmacionGuardado)
        }

    }

    // Todos los campos son OBLIGATORIOS para agregar/guardar/modificar. Un combo sin
    // elegir vale 0 (numero) y un texto vacio vale "" -> ambos se rechazan.
    camposValidos = () => {
        const campos = [
            this.state.cmbTiposImpresora,
            this.state.cmbProtocolos,
            this.state.txtPuerto,
            this.state.cmbVelocidades,
            this.state.txtArchivo,
            this.state.cmbDebugs,
            this.state.cmbEstados
        ]
        const vacio = campos.some(v => v === undefined || v === null || v === 0 || (typeof v === 'string' && v.trim() === ""))
        if (vacio) {
            window.alert("Todos los campos son obligatorios para guardar.")
            return false
        }
        return true
    }

    btnGuardarClick = () => {
        if (!this.camposValidos()) return

        var dispositivos = this.state.dispositivos

        var item = {
            tipo: this.state.cmbTiposImpresora,
            protocolo: this.state.cmbProtocolos,
            puerto: this.state.txtPuerto,
            velocidad: this.state.cmbVelocidades,
            archivo: this.state.txtArchivo,
            debug: this.state.cmbDebugs,
            estado: this.state.cmbEstados
        }

        if(this.state.modoEdicion) {
            var x = dispositivos.indexOf(this.state.itemEdicion)
            if(x >= 0) dispositivos[x] = item
        } else {
            dispositivos.push(item)
        }

        this.setState({
            dispositivos: dispositivos
        })

        this.guardarEvent(this.state.tipoDispositivo, this.state.dispositivos, this.confirmacionGuardado)
    }

    pepararNuevo = () => {
        this.setState({
            itemEdicion: null,
            cmbTiposImpresora: 0,
            cmbProtocolos: 0,
            txtPuerto: "",
            cmbVelocidades: 0,
            txtArchivo: "",
            cmbDebugs: 0,
            cmbEstados: 0,
            modoEdicion: false
        })
    }

    confirmacionGuardado = () => {
        this.pepararNuevo()
    }

    render() {
        const columns = [
            {field: 'Tipo', headerName: 'Tipo', width: 100},
            {field: 'Protocolo', headerName: 'Protocolo', width: 100},
            {field: 'Puerto', headerName: 'Puerto', width: 100},
            {field: 'Velocidad', headerName: 'Velocidad', width: 50},
            {field: 'Archivo', headerName: 'Archivo', width: 100},
            {field: 'Debug', headerName: 'Debug', width: 50},
            {field: 'Estado', headerName: 'Estado', width: 50},
            {field: '', headerName: '', width: 50}
          ]

        return(
            <Box>
                <Grid container xs={12}>
                    <Grid item xs={12}>
                        <Card fullWidth>
                            <CardContent>
                            	<h3>Impresoras</h3>
                                <form>
                                    <FormLabel>Información impresora</FormLabel>
                                    <br />
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Tipo</InputLabel>
                                            <Select
                                                label="Tipo"
                                                value={this.state.cmbTiposImpresora}
                                                defaultValue={0}
                                                onChange={this.onChangecmbTiposImpresora}>
                                                <MenuItem value={0}>-- Seleccione Tipo --</MenuItem>
                                                {this.state.tiposImpresora.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Protocolo</InputLabel>
                                            <Select
                                                label="Protocolo"
                                                value={this.state.cmbProtocolos}
                                                defaultValue={0}
                                                onChange={this.onChangecmbProtocolos}>
                                                <MenuItem value={0}>-- Seleccione Protocolo --</MenuItem>
                                                {this.state.protocolos.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <TextField
                                            label="Puerto"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={this.state.txtPuerto}
                                            onChange={this.onChangetxtPuerto}
                                            fullWidth
                                            />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Velocidad</InputLabel>
                                            <Select
                                                label="Velocidad"
                                                value={this.state.cmbVelocidades}
                                                defaultValue={0}
                                                onChange={this.onChangecmbVelocidades}>
                                                <MenuItem value={0}>-- Seleccione Velocidad --</MenuItem>
                                                {this.state.velocidades.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <TextField
                                            label="Archivo"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={this.state.txtArchivo}
                                            onChange={this.onChangetxtArchivo}
                                            fullWidth
                                            />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Debug</InputLabel>
                                            <Select
                                                label="Debug"
                                                value={this.state.cmbDebugs}
                                                defaultValue={0}
                                                onChange={this.onChangecmbDebugs}>
                                                <MenuItem value={0}>-- Seleccione Debug --</MenuItem>
                                                {this.state.debugs.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Estado</InputLabel>
                                            <Select
                                                label="Estado"
                                                value={this.state.cmbEstados}
                                                defaultValue={0}
                                                onChange={this.onChangecmbEstados}>
                                                <MenuItem value={0}>-- Seleccione estado --</MenuItem>
                                                {this.state.estados.map(item => (
                                                <MenuItem value={item.valor}>{item.nombre}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </form>
                            </CardContent>
                            <CardActions>
                                <Button  variant="contained" onClick={this.btnGuardarClick}>{ this.state.modoEdicion  === true ? "Modificar": "Agregar"}</Button>
                                <Button  variant="contained" onClick={this.pepararNuevo}>Cancelar</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
                <br />
                <Card xs={8}>
                    <CardContent xs={8}>
                        <TableContainer xs={8}>
                            <Table stickyHeader class="table-data" xs={8}>
                                <TableHead>
                                    <TableRow>
                                        {
                                            columns.map((column) => {
                                                return(
                                                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                </TableHead>
                                {
                                    this.state.dispositivos.map((dispositivo) => {
                                        return(<Row item = {dispositivo} eventSelect={this.btnSeleccionarClick} eventDelete={this.btnBorrarClick} />)
                                    })
                                }
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            </Box>
        )
    }
}

export default TabImpresoras